module.exports = __webpack_public_path__ + "static/media/link.50c67f3c.svg";